import { createContext } from 'react'

import type { UseTimelineProviderReturn } from './use-timeline'

export type TimelineContext = Partial<UseTimelineProviderReturn>

export const TimelineContext = createContext<TimelineContext>({})
